import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const Success = () => {
  console.log("Success");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (sessionId) {
      // Use HTTPS URL for the API
      const apiUrl = process.env.REACT_APP_API_URL || 'https://atabackend.quindl.com';

      fetch(`${apiUrl}/checkout-session/${sessionId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        credentials: 'include'
      })
        .then((response) => {
          if (!response.ok) {
            console.error(`HTTP Error: ${response.status} ${response.statusText}`);
            throw new Error(`Failed to fetch session details: ${response.statusText}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.payment_status === "paid") {
            console.log("Payment successful");
            const pendingOrder = localStorage.getItem('pendingOrder');
            if (pendingOrder) {
              console.log("Pending order found");
              const orderData = JSON.parse(pendingOrder);

              // Clear the pending order from localStorage
              localStorage.removeItem('pendingOrder');
              setIsProcessing(false);
              toast.success("Payment successful!");
            }
          } else {
            console.error("Payment failed. Server response:", data);
            setError("Payment verification failed");
            toast.error("Payment Failed.");
            setIsProcessing(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching session details:", {
            message: error.message,
            stack: error.stack,
            sessionId,
          });

          // Handle SSL errors specifically
          if (error.message.includes('SSL') || error.message.includes('HTTPS')) {
            setError("SSL Connection Error: Please ensure you're using HTTPS");
            toast.error("SSL Connection Error");
          } else {
            setError("An error occurred while verifying payment");
            toast.error("An error occurred. Please try again.");
          }

          localStorage.removeItem('pendingOrder');
          setIsProcessing(false);
        });
    } else {
      setIsProcessing(false);
      setError("No session ID found");
      toast.error("No session ID found");
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg text-center">
        {isProcessing ? (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Processing Your Order</h2>
            <p className="text-gray-600">Please wait while we confirm your payment...</p>
          </>
        ) : error ? (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Error</h2>
            <p className="text-gray-600 mb-6">{error}</p>
            <button
              onClick={() => navigate('/')}
              className="bg-purple-500 text-white px-6 py-2 rounded-full hover:bg-purple-600 transition-colors"
            >
              Return to Home
            </button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Thank You!</h2>
            <p className="text-gray-600 mb-6">Your order has been successfully processed.</p>
            <button
              onClick={() => navigate('/')}
              className="bg-purple-500 text-white px-6 py-2 rounded-full hover:bg-purple-600 transition-colors"
            >
              Continue Shopping
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Success; 